import React, {Suspense} from 'react';
import {ErrorBoundary} from 'react-error-boundary';
import {useNavigate} from 'react-router';
import {useSearchParams} from 'react-router-dom';
import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import ConsentBannerKr from '@di-shared/features/home/kr/ConsentBanner.kr';
import ConsentBannerLoadingKr from '@di-shared/features/home/kr/ConsentBannerLoading.kr';
import MileageBalance from '@di-shared/features/mileage/ecomileage/MileageBalance';
import {ROUTE_PATHS} from '@di-shared/routes';

interface MileageBalancePage {
  vin: string;
}

function MileageBalancePage({vin}: MileageBalancePage) {
  const {t} = useInferableTranslation();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const hiddenTabs = searchParams.get('hideTab')?.split('|') || [];
  const isTabVisible = (tabName: string) => !hiddenTabs.includes(tabName);

  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Header left={<HeaderBackButton />}>
        <h1 className="headline_xxsmall nav_center_title">{t('T40049')}</h1>
      </Header>
      <main
        id="content"
        className="content page_eco_mileage"
      >
        <ErrorBoundary fallback={<></>}>
          <Suspense fallback={<ConsentBannerLoadingKr />}>
            <ConsentBannerKr vin={vin} />
          </Suspense>
        </ErrorBoundary>
        <div className="tabbar_txt tabbar_sticky">
          <div className="inner">
            {isTabVisible('eco') && (
              <button
                type="button"
                className="tabbar_item body_large_r"
                onClick={() => navigate(ROUTE_PATHS.MILEAGE_ECO.getFullPath(vin), {replace: true})}
              >
                <span className="txt">{t('T40053')}</span>
              </button>
            )}
            {isTabVisible('safe') && (
              <button
                type="button"
                className="tabbar_item body_large_r"
                onClick={() => navigate(ROUTE_PATHS.MILEAGE_SAFE_DRIVING.getFullPath(vin), {replace: true})}
              >
                <span className="txt">{t('T30253')}</span>
              </button>
            )}
            {isTabVisible('balance') && (
              <button
                type="button"
                className="tabbar_item body_large_r is-selected"
                onClick={() => navigate(ROUTE_PATHS.MILEAGE_BALANCE.getFullPath(vin), {replace: true})}
              >
                <span className="txt">{t('T30177')}</span>
              </button>
            )}
          </div>
        </div>
        <div className="tab_content regular_mileage">
          <MileageBalance vin={vin} />
        </div>
      </main>
    </div>
  );
}

export default MileageBalancePage;
